<template>
  <v-content class="gb owner-add-vendors">
    <div class="back-container" style>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12">
          <div class="custom-position-back">
            <v-btn rounded depressed class="back-btn" @click="$router.push('/owner/vendors')">
              <img alt="" :src="require('@/assets/img/back.svg')" class="mr-2"/>
              back
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-container class="fill-width" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12">
          <v-card :loading="status === 'loading' || status_service === 'loading'" style="padding-top: 0;"
                  class="fill-width card-theme custom-container">
            <v-row align="center" class="flex-colum px-8" style="padding-top: 47px;">
              <v-col lg4 xs12 style="padding: 0!important;">
                <h2 class="azul custom-o-title">Add New Vendor</h2>
              </v-col>
              <v-col lg8 xs12 style="text-align: end;">
                <v-btn
                    rounded
                    depressed
                    class="px-4 ml-4 btn-blanco btn-blanco--a"
                    style="text-transform: capitalize; font-size: 12px;"
                    @click="downloadTemplate"
                >
                  <v-icon x-small class="mr-1">fa-download</v-icon>
                  Download Template
                </v-btn>
                <v-btn
                    rounded
                    depressed
                    class="px-4 ml-4 btn-blanco btn-blanco--a"
                    style="text-transform: capitalize; font-size: 12px;"
                    @click="$refs.fileInput.click()"
                >
                  <v-icon x-small class="mr-1">fa-upload</v-icon>
                  Upload CSV/Excel
                </v-btn>
                <input
                    ref="fileInput"
                    type="file"
                    accept=".csv,.xlsx,.xls"
                    style="display: none;"
                    @change="handleFileUpload"
                />
                <v-btn
                    rounded
                    depressed
                    class="px-6 ml-2 btn-blanco btn-blanco--a"
                    style="text-transform: capitalize;"
                    @click="addNewVendor"
                >+ Add New Vendor
                </v-btn>
              </v-col>
            </v-row>

            <!-- Upload status summary (plain text, not banners) -->
            <div v-if="uploadSummary || issuesList.length > 0" class="px-8 mt-3">
              <div v-if="uploadSummary" style="font-size: 13px; color: #7a7a7a;">
                {{ uploadSummary }}<span v-if="issuesList.length > 0"> — {{ issuesList.length }} issue{{ issuesList.length !== 1 ? 's' : '' }} to fix</span>
              </div>
              <div v-if="parseError" style="font-size: 13px; color: #d32f2f; margin-top: 4px;">
                {{ parseError }}
              </div>
              <ul v-if="issuesList.length > 0" class="upload-issues-list">
                <li v-for="(issue, idx) in issuesList" :key="idx">{{ issue }}</li>
              </ul>
            </div>

            <ValidationObserver ref="validator" v-slot="{}">
              <div class="vendor-entries px-4 mt-6">
                <div v-for="(item, index) in vendors" :key="index" class="vendor-entry">
                  <div class="vendor-fields">
                    <v-row>
                      <v-col cols="4">
                        <ValidationProvider
                            ref="company_name"
                            mode="lazy"
                            rules="required"
                            v-slot="{ errors }"
                        >
                          <v-text-field
                              v-model="item.company_name"
                              :error-messages="errors"
                              label="Company Name"
                              name="company_name"
                              type="text"
                              required
                              class="ui-label change_bord especial_border custom-input-position-text label-medium"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="4">
                        <ValidationProvider
                            ref="firstName"
                            mode="lazy"
                            rules="required"
                            v-slot="{ errors }"
                        >
                          <v-text-field
                              v-model="item.first_name"
                              :error-messages="errors"
                              label="First Name"
                              name="firstName"
                              type="text"
                              required
                              class="ui-label change_bord especial_border custom-input-position-text label-medium"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="4">
                        <ValidationProvider
                            ref="lastName"
                            mode="lazy"
                            rules="required"
                            v-slot="{ errors }"
                        >
                          <v-text-field
                              v-model="item.last_name"
                              :error-messages="errors"
                              label="Last Name"
                              name="lastName"
                              type="text"
                              required
                              class="ui-label change_bord especial_border custom-input-position-text label-medium"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4">
                        <ValidationProvider
                            ref="email"
                            mode="lazy"
                            rules="required|email"
                            v-slot="{ errors }"
                        >
                          <v-text-field
                              v-model="item.email"
                              :error-messages="errors"
                              label="Email"
                              name="email"
                              type="text"
                              required
                              class="ui-label change_bord especial_border custom-input-position-text label-medium"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="4">
                        <ValidationProvider
                            ref="phone"
                            mode="lazy"
                            rules="required|size:10"
                            v-slot="{ errors }"
                        >
                          <v-text-field
                              v-model="item.phone_number"
                              :error-messages="item.phone_error ? [item.phone_error] : errors"
                              label="Cell Phone"
                              name="phone"
                              type="text"
                              v-mask="mask"
                              required
                              class="ui-label change_bord especial_border custom-input-position-text label-medium"
                              @input="clearPhoneError(item)"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="4">
                        <span class="group" v-if="item.service !== ''">
                          <ValidationProvider
                              ref="service"
                              mode="lazy"
                              rules="required"
                              v-slot="{ errors }"
                          >
                            <v-autocomplete
                                :error-messages="errors"
                                :items="services_main"
                                item-text="text"
                                class="ui-label change-whitd change_bord especial_border custom-input-position-text label-medium service-field"
                                v-model="item.service"
                                @keydown="list($event,'grow', item.service)"
                                @change="onServiceChange($event, item)"
                                v-on:blur="list($event,'blur')"
                            >
                              <template v-slot:label>
                                <span>Service</span>
                                <v-tooltip top max-width="300">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        style="color: #29abe2; font-size: 16px; margin-left: 4px; vertical-align: middle;"
                                    >info</v-icon>
                                  </template>
                                  <span>To suggest a new category, email: Support@kiey.com</span>
                                </v-tooltip>
                              </template>

                              <template v-slot:append>
                                <img
                                    :src="require('@/assets/img/dropdown-blue.svg')"
                                    style="position: relative;top: 13px;"
                                    class="arrow-year"
                                    alt
                                />
                              </template>

                              <template v-slot:append-item>
                                <v-list-item
                                    v-on:click="list(null, 'all')"
                                    style="cursor:pointer !important;"
                                    v-show="service_length < 12"
                                >
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      More
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </span>
                        <span v-if="item.service === ''" class="group">
                          <keep-alive>
                            <ValidationProvider ref="other" rules="required" v-slot="{ errors }">
                              <v-text-field
                                  v-model="item.service_other"
                                  :error-messages="item.service_unmatched ? ['Not recognized — select from dropdown or keep as Other'] : errors"
                                  name="other"
                                  type="text"
                                  placeholder="Other"
                                  required
                                  class="ui-label change_bord especial_border custom-input-position-text label-medium service-field"
                                  @input="clearServiceError(item)"
                              >
                                <template v-slot:label>
                                  <span>Service</span>
                                  <v-tooltip top max-width="300">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                          v-bind="attrs"
                                          v-on="on"
                                          style="color: #29abe2; font-size: 16px; margin-left: 4px; vertical-align: middle;"
                                      >info</v-icon>
                                    </template>
                                    <span>To suggest a new category, email: Support@kiey.com</span>
                                  </v-tooltip>
                                </template>
                                <template v-slot:append>
                                  <v-icon class="close-other-option" @click="resetService(item)">close</v-icon>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </keep-alive>
                        </span>
                      </v-col>
                    </v-row>
                    <v-alert v-if="item.error" border="top" color="red lighten-2" dark>{{ item.error }}</v-alert>
                  </div>
                  <div class="vendor-remove">
                    <span @click="removeItem(item)" class="remove-data">
                      <img :src="require('@/assets/img/close_red.svg')"/>
                    </span>
                  </div>
                </div>
              </div>
              <v-card-text class="px-5" style="padding-top: 0 !important;">
                <div class="pl-7">
                  <!-- Progress bar during submission -->
                  <div v-if="status === 'loading' && submitTotal > 0" class="mb-4">
                    <div style="font-size: 14px; color: #061d47; margin-bottom: 8px;">
                      Submitting {{ submitProgress }} of {{ submitTotal }} vendors...
                    </div>
                    <v-progress-linear
                        :value="(submitProgress / submitTotal) * 100"
                        color="#29abe2"
                        height="8"
                        rounded
                    ></v-progress-linear>
                  </div>

                  <ValidationProvider
                      mode="lazy"
                      name="terms"
                      ref="terms"
                      rules="required-check"
                      v-slot="{ errors }"
                  >
                    <v-checkbox
                        v-model="agree_terms"
                        :error-messages="errors"
                        required
                        class="label-checkbox-vendor chk medium custom-check-box vendor-checkbox"
                        color="blue darken-1"
                    >
                      <div slot="label" class="terms-privacy-agreement" style="color: #061d47;">
                        I understand that upon clicking submit, the users listed above will
                        receive email and text notifications granting them access to sign up
                        under my account.
                      </div>
                    </v-checkbox>
                  </ValidationProvider>

                  <div class="text-center pt-10">
                    <v-btn
                        :loading="status === 'loading'"
                        :disabled="status === 'loading' || hasBlockingErrors"
                        rounded
                        depressed
                        class="ml-6 btn-azul"
                        @click="submit"
                    >SUBMIT
                    </v-btn>
                  </div>
                </div>
              </v-card-text>
            </ValidationObserver>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import {ValidationProvider, ValidationObserver} from "vee-validate";
import {mask} from "vue-the-mask";
import {mapState, mapActions, mapMutations} from "vuex";
import ExcelJS from "exceljs";

export default {
  name: "AddUsers",
  async created() {
    if (this.$store.getters["Authenticate/isLoggedIn"]) {
      this.setHideOther(false);
      this.addNewVendor();
      await this.get_services();
      this.segment_services('all');
      this.segment_services(10);
    } else {
      this.$router.push("/owner/sign_up");
    }
  },
  directives: {
    mask,
  },
  computed: {
    ...mapState({
      status_service: (state) => state.Services.status,
      status: (state) => state.Owner_sign_up_add_vendors.status,
      services_store: (state) => state.Services.slice_services,
      all_services: (state) => state.Services.services,
      user: (state) => state.Authenticate.user,
      submitProgress: (state) => state.Owner_sign_up_add_vendors.submitProgress,
      submitTotal: (state) => state.Owner_sign_up_add_vendors.submitTotal,
    }),
    hasBlockingErrors() {
      if (this.parseError) return true;
      return this.vendors.some(v => v.phone_error || v.service_unmatched);
    },
    issuesList() {
      const issues = [];
      this.vendors.forEach((v, i) => {
        const row = i + 1;
        if (v.phone_error) issues.push(`Row ${row}: ${v.phone_error}`);
        if (v.service_unmatched) issues.push(`Row ${row}: Service "${v.service_other}" not recognized`);
      });
      return issues;
    },
  },
  watch: {
    services_store() {
      this.service_length = this.services_store.length;
      this.services_main = [];
      this.services_main.length = 0;
      if (this.queryText && this.queryText !== "") {
        this.services_main.push(this.queryText)
      }
      for (const prop in this.services_store) {
        this.services_main.push(this.services_store[prop])
      }
    }
  },
  data() {
    return {
      agree_terms: false,
      mask: "### - ### - ####",
      showSkipVendorsModal: false,
      showOnboardingCompleteModal: false,
      checkbox: false,
      showSkip: false,
      showSkipA: false,
      step: 2,
      service_other: "",
      service: "",
      search: "",
      vendors: [],
      queryText: null,
      service_length: 0,
      services_main: [],
      uploadSummary: "",
      parseError: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    ...mapMutations({
      setHideOther: 'Services/setHideOther',
    }),
    ...mapActions({
      get_services: "Services/get_services",
      segment_services: "Services/segment_services"
    }),
    removeItem(a) {
      this.vendors.splice(this.vendors.indexOf(a), 1);
    },
    clearPhoneError(item) {
      this.$set(item, 'phone_error', '');
    },
    clearServiceError(item) {
      this.$set(item, 'service_unmatched', false);
    },
    onServiceChange($event, item) {
      this.list($event, 'reduce');
      this.$set(item, 'service_unmatched', false);
    },
    resetService(item) {
      item.service = null;
      item.service_other = "";
      this.$set(item, 'service_unmatched', false);
    },
    async submit() {
      const self = this;
      const valid = await this.$refs.validator.validate();
      if (valid) {
        self.$store
            .dispatch("Owner_sign_up_add_vendors/add_vendors", self.vendors)
            .then(async (contErrors) => {
              if (contErrors === 0) {
                await self.$store.dispatch("Users_list/clear_data", true);
                self.$router.push("/owner/vendors");
              } else {
                await this.$refs.validator.validate();

                for (let i = 0; i < self.vendors.length; i++) {
                  if (self.vendors[i].error === '') {
                    self.vendors.splice(i, 1);
                  }
                }
              }
            })
            .catch(function (error) {
              console.error(error);
            });
      }
    },

    async list($event, option, item_service) {
      switch (option) {
        case 'grow':
          if (item_service === undefined) {
            this.segment_services(10);
          } else {
            await this.segment_services("all");
          }
          break;
        case 'reduce':
          this.segment_services(10);

          this.queryText = null;
          if ($event && $event !== "") {
            this.queryText = {
              value: $event,
              text: $event,
            };
          }
          break;
        case 'blur':
          this.segment_services(10);
          break;
        case 'all':
          this.segment_services('all');
          break;
      }
    },

    addNewVendor: function () {
      this.vendors.push({
        company_name: "",
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        service: null,
        service_other: "",
      });
    },
    onClickSkipVendorsModal() {
      this.showOnboardingCompleteModal = true;
      this.showSkipVendorsModal = false;
    },
    hideSkipModal() {
      this.showSkipVendorsModal = false;
    },
    hideOnboardingCompleteModal() {
      this.showOnboardingCompleteModal = false;
    },
    downloadTemplate() {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('Vendors');
      sheet.columns = [
        { header: 'Company Name', key: 'company_name', width: 25 },
        { header: 'First Name', key: 'first_name', width: 20 },
        { header: 'Last Name', key: 'last_name', width: 20 },
        { header: 'Email', key: 'email', width: 30 },
        { header: 'Phone Number', key: 'phone_number', width: 20 },
        { header: 'Service', key: 'service', width: 25 },
      ];
      sheet.getRow(1).font = { bold: true };
      sheet.addRow({
        company_name: 'ABC Plumbing',
        first_name: 'Jane',
        last_name: 'Smith',
        email: 'jane@abcplumbing.com',
        phone_number: '5559876543',
        service: 'Plumbing',
      });
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'vendor_upload_template.xlsx';
        a.click();
        URL.revokeObjectURL(url);
      });
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.$refs.fileInput.value = '';

      this.uploadSummary = '';
      this.parseError = '';

      try {
        const workbook = new ExcelJS.Workbook();
        const buffer = await file.arrayBuffer();

        if (file.name.endsWith('.csv')) {
          await workbook.csv.load(buffer);
        } else {
          await workbook.xlsx.load(buffer);
        }

        const sheet = workbook.worksheets[0];
        if (!sheet) {
          this.parseError = 'No worksheet found in file.';
          return;
        }

        // Map header names to our fields
        const headerMap = {};
        const headerRow = sheet.getRow(1);
        headerRow.eachCell((cell, colNumber) => {
          const val = String(cell.value || '').trim().toLowerCase();
          if (val.includes('company') || val.includes('business')) headerMap[colNumber] = 'company_name';
          else if (val.includes('first') && val.includes('name')) headerMap[colNumber] = 'first_name';
          else if (val.includes('last') && val.includes('name')) headerMap[colNumber] = 'last_name';
          else if (val.includes('email')) headerMap[colNumber] = 'email';
          else if (val.includes('phone') || val.includes('cell') || val.includes('mobile')) headerMap[colNumber] = 'phone_number';
          else if (val.includes('service') || val.includes('category') || val.includes('trade')) headerMap[colNumber] = 'service';
        });

        const requiredFields = ['first_name', 'last_name', 'email', 'phone_number'];
        const mappedFields = Object.values(headerMap);
        const missingFields = requiredFields.filter(f => !mappedFields.includes(f));
        if (missingFields.length > 0) {
          this.parseError = 'Your file is missing some required columns. Please download the template and make sure it includes: First Name, Last Name, Email, and Phone Number.';
          return;
        }

        // Build a lookup from the FULL services list (not the sliced/paginated one)
        const serviceNames = this.all_services
            .filter(s => s && s.value)
            .map(s => ({ text: s.text, value: s.value, lower: String(s.text).toLowerCase() }));

        const parsedVendors = [];
        const phonesSeen = {};

        sheet.eachRow((row, rowNumber) => {
          if (rowNumber === 1) return;

          const entry = {
            company_name: '',
            first_name: '',
            last_name: '',
            email: '',
            phone_number: '',
            service: null,
            service_other: '',
            phone_error: '',
            service_unmatched: false,
          };

          row.eachCell((cell, colNumber) => {
            const field = headerMap[colNumber];
            if (!field) return;
            let val = cell.value;
            if (val && typeof val === 'object' && val.richText) {
              val = val.richText.map(r => r.text).join('');
            }
            if (val && typeof val === 'object' && val.text) {
              val = val.text;
            }
            val = String(val || '').trim();

            if (field === 'phone_number') {
              let digits = val.replace(/\D/g, '');
              if (digits.length === 11 && digits.startsWith('1')) {
                digits = digits.substring(1);
              }
              if (digits.length === 10) {
                entry.phone_number = digits.substring(0, 3) + ' - ' + digits.substring(3, 6) + ' - ' + digits.substring(6);
              } else if (digits.length > 0) {
                entry.phone_number = val;
                entry.phone_error = 'Phone number must be 10 digits';
              }
            } else if (field === 'service') {
              const lowerVal = val.toLowerCase();
              const match = serviceNames.find(s => s.lower === lowerVal);
              if (match) {
                entry.service = match.value;
              } else if (val) {
                entry.service = '';
                entry.service_other = val;
                entry.service_unmatched = true;
              }
            } else {
              entry[field] = val;
            }
          });

          // Skip completely empty rows
          if (!entry.first_name && !entry.last_name && !entry.email && !entry.phone_number) return;

          // Check for duplicate phones
          const cleanPhone = entry.phone_number.replace(/\D/g, '');
          if (cleanPhone && phonesSeen[cleanPhone]) {
            entry.phone_error = 'Duplicate phone number';
          }
          phonesSeen[cleanPhone] = true;

          parsedVendors.push(entry);
        });

        if (parsedVendors.length === 0) {
          this.parseError = 'No data rows found in file.';
          return;
        }

        this.vendors = parsedVendors;
        // Expand dropdown to show all services so matched values display
        this.segment_services('all');
        this.uploadSummary = `${parsedVendors.length} vendor${parsedVendors.length !== 1 ? 's' : ''} loaded from ${file.name}`;
      } catch (err) {
        console.error('File parse error:', err);
        this.parseError = 'Unable to read this file. Please download the template and ensure your file is saved as .csv or .xlsx before uploading.';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.remove-data {
  cursor: pointer;
}

.upload-issues-list {
  margin: 4px 0 0 0;
  padding-left: 18px;
  list-style: none;

  li {
    font-size: 12px;
    color: #d32f2f;
    line-height: 1.6;

    &::before {
      content: "\2022";
      color: #d32f2f;
      display: inline-block;
      width: 12px;
      margin-left: -12px;
    }
  }
}

.owner-add-vendors {
  .custom-container {
    max-width: 1290px !important;
    min-height: 558px;
    top: 0;
    margin-bottom: 50px !important;
    padding: 47px 49px 47px;
  }

  .custom-o-title {
    font-size: 30px;
    font-weight: 500;
    line-height: 34px;
    font-family: "Roboto-Medium", sans-serif !important;
    top: -10px;
    position: relative;
  }

  .btn-blanco--a {
    font-family: Roboto, sans-serif;
    font-size: 13px !important;
    letter-spacing: 0.5px;
    color: #2bace2 !important;
    font-weight: 400;
    border-radius: 24px;
    border: 2px solid #29abe2;
  }

  .service-field ::v-deep .v-label {
    overflow: visible !important;
    pointer-events: auto !important;
  }
}

.vendor-entry {
  display: flex;
  align-items: flex-start;
  padding: 16px 0;
}

.vendor-entry + .vendor-entry {
  border-top: 2px solid #061d47;
}

.vendor-fields {
  flex: 1;
  min-width: 0;
}

.vendor-remove {
  display: flex;
  align-items: center;
  padding-left: 16px;
}
</style>
<style>
  .owner-add-vendors .vendor-fields .v-text-field input {
    padding-top: 12px !important;
  }
</style>
